import { useDevice } from "@hooks/useDevice";
import type { ItemResponse } from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import ItemResponseForm from "components/ItemResponseForm";

type Props = {
	itemResponse: ItemResponse;
	countryCode?: string;
	updateFormStates: (formStates: Record<string, string>) => void;
	disabled?: boolean;
	correct?: Record<string, { isCorrect?: boolean; response?: string }>;
};

const NoteCompletion = ({
	itemResponse,
	countryCode,
	updateFormStates,
	disabled = false,
	correct,
}: Props) => {
	const { isMobile, isMediumWindowSize } = useDevice();

	return (
		<Box paddingHorizontal={isMobile || isMediumWindowSize ? 16 : 0}>
			<ItemResponseForm
				formConfig={itemResponse}
				onWatch={updateFormStates}
				countryCode={countryCode}
				disabled={disabled}
				correct={correct}
			/>
		</Box>
	);
};

export default NoteCompletion;
